module.exports = __webpack_public_path__ + "static/media/logo_megapay.888d8eef.png";